export const accuracyDatabaseTableConfiguration = {
    tableInfo: {
        type: 'dataTable',
        title: {
            display: true,
            text: '',
            align: 'center', // where to align the element within div i.e left, center or right
            order: 'order-md-2' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
        },
    },
    css: {
        tableClass: 'table table-striped table-bordered m-0',
        theadClass: '',
        tbodyClass: ''
    },
    sortOptions: {
        sortIndex: 0,
        sortType: 'desc'
    },
    searchFilter: {
        display: false,
        align: 'left', // where to align the element within div i.e left, center or right
        order: 'order-md-1' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    breadcrumbCons: {
        show: true,
        queryparams: []
    },
    downloadButton: {
        
        display: false,
        text: 'Download',
        align: 'right', // where to align the element within div i.e left, center or right
        order: 'order-md-3' // Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    // downloadOptions: [
    //     {
    //         downloadType: 'xlsx',
    //         downloadFileName: 'Unified Farmer Database',
    //         downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
    //         metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
    //     },
    //     {
    //         downloadType: 'pdf',
    //         downloadFileName: 'Unified Farmer Database',
    //         downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
    //         metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
    //     },
    //     {
    //         downloadType: 'csv',
    //         downloadFileName: 'Unified Farmer Database',
    //         downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
    //         metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
    //     }
    // ],
    printButton: {
        display: true,
        text: 'Print',
        align: 'right',       //where to align the element within div i.e left, center or right
        order: 'order-md-2',   //Order of the element from left. defined in DataTableModule.toolBarElementOrder
        title: 'Sites'
    },
    paginatorOptions: {
        visible: false,
        limit: 20,
        maxSize: 5,
        directionLinks: 'true',
        autoHide: 'true',
        previousLabel: 'previous',
        nextLabel: 'next',
        dropdownOptions: [{
            value: 5,
            display: '5'
        },
        {
            value: 10,
            display: '10'
        },
        {
            value: 15,
            display: '15'
        },
        {
            value: 20,
            display: '20'
        },
        {
            value: 25,
            display: '25'
        },
        {
            value: -1,
            display: 'All'
        }
        ]
    },
    tableHeaderFixerInfo: {
        headerFix: true,
        colFix: true,
        rowFix: false, // If we want to fix the data rows as well.
        noOfCol: 1,
        noOfRow: 1, // no of data rows from top that needs to be fixed
        height: '500px',
        showHeight: false // If we want to set Height of table
    },
    totalRow: {
        position: 'bottom', // top, bottom
        displayAs: '', // Custom text to display, default 'Total'
        name: 'Total',
        jsonKey: '-1',
        colspan: 1, // How many columns should it span to, this will start from the far left so add +1 to make up for S.No column
        class: 'fixed-row',
        key: 'lUUID'
    },
    indexCons: {
        show: false,
        class: 'tc-bg-01',
        tooltip: 'S.No'
    },
    columns: []
}

export const BaseLevelColumnConfig = [
    {
        name: 'State',
        jsonKey: {
            path: 'name##uuid'
        },
        class: 'tc-bg-01',
        dataType: 'LOCATION',
        defaultValue: '-'
    },
    {
        name: 'Actual(°C)',
        jsonKey: {
            // path: 'heatwatch_timeStamp1.n'
            path: 'actualtimeStamp1'
        },
        class: 'tc-bg-01',
        dataType: 'FLOAT',
        defaultValue: '-'
    },
    {
        name:'ONE DAY OUT',
        childs:[{
           name: 'Forecast(°C)',
           jsonKey: {
               path: 'timeStamp1'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       },
       {
           name: 'Accuracy(%)',
           jsonKey: {
               path: 'accuracy_timeStamp1'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       }]
    },
  
    {
        name:'TWO DAY OUT',
        childs:[{
           name: 'Forecast(°C)',
           jsonKey: {
               path: 'timeStamp2'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       },
       {
           name: 'Accuracy(%)',
           jsonKey: {
               path: 'accuracy_timeStamp2'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       }]
    },
    {
        name:'THREE DAY OUT',
        childs:[{
           name: 'Forecast(°C)',
           jsonKey: {
               path: 'timeStamp3'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       },
       {
           name: 'Accuracy(%)',
           jsonKey: {
               path: 'accuracy_timeStamp3'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       }]
    },
    {
        name:'FOUR DAY OUT',
        childs:[{
           name: 'Forecast(°C)',
           jsonKey: {
               path: 'timeStamp4'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       },
       {
           name: 'Accuracy(%)',
           jsonKey: {
               path: 'accuracy_timeStamp4'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       }]
    },
   
    {
        name:'FIVE DAY OUT',
        childs:[{
           name: 'Forecast(°C)',
           jsonKey: {
               path: 'timeStamp5'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       },
       {
           name: 'Accuracy(%)',
           jsonKey: {
               path: 'accuracy_timeStamp5'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       }]
    },
    {
        name:'SIX DAY OUT',
        childs:[{
           name: 'Forecast(°C)',
           jsonKey: {
               path: 'timeStamp6'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       },
       {
           name: 'Accuracy(%)',
           jsonKey: {
               path: 'accuracy_timeStamp6'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       }]
    },
    {
        name:'SEVEN DAY OUT',
        childs:[{
           name: 'Forecast(°C)',
           jsonKey: {
               path: 'timeStamp7'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       },
       {
           name: 'Accuracy(%)',
           jsonKey: {
               path: 'accuracy_timeStamp7'
           },
           class: 'tc-bg-01',
           dataType: 'FLOAT',
           defaultValue: '-',
       }]
    },
]